module.exports = __webpack_public_path__ + "img/floorplan-3.0b1778e4.png";